import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppMenuDigital from './AppMenuDigital';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import CookieConsent from "react-cookie-consent";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter >
    {/* // <React.StrictMode> */}
    <AppMenuDigital />
    {/* // </React.StrictMode> */}
    <CookieConsent
      location="bottom"
      buttonText="Aceptar"
      //declineButtonText="Rechazar"
      cookieName="mi_cookie_consent"
      style={{ background: "rgba(0,0,0,0.85)", fontSize: "14px" }}
      buttonStyle={{ backgroundColor: "#FFD700", color: "#000", fontSize: "14px" }}
      //enableDeclineButton
      onAccept={() => console.log("Cookies aceptadas")}
      //onDecline={() => console.log("Cookies rechazadas")}
    >
      Usamos cookies. Al continuar aceptas nuestra Política de Datos y Términos de Uso.{" "}
      <a href="/politica-cookies" style={{ color: "#FFD700" }}>
        Ver política
      </a>
    </CookieConsent>
  </BrowserRouter>
);

reportWebVitals();
